import { render } from "./UppyUploader.vue?vue&type=template&id=1009cba2"
import script from "./UppyUploader.vue?vue&type=script&lang=js"
export * from "./UppyUploader.vue?vue&type=script&lang=js"

import "./UppyUploader.vue?vue&type=style&index=0&id=1009cba2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UppyUploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1009cba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1009cba2', __exports__)) {
    api.reload('1009cba2', __exports__)
  }
  
  module.hot.accept("./UppyUploader.vue?vue&type=template&id=1009cba2", () => {
    api.rerender('1009cba2', render)
  })

}


export default __exports__